/* eslint-disable max-len */
import React from 'react'
import { useState,useEffect, useCallback,useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import CustomeDatePicker from '../../../../components/DatePicker'
import moment from 'moment';
import Table from './Components/Table';
import SearchBar from './Components/SearchBar/Search';
import UpdateButton from '../../../../components/UpdateButton';
import { dataService } from '../../../../services/data.services';
import {useDispatch, useSelector } from 'react-redux';
import GlobalContext from '../../../../components/Context/GloablContext';
import { resetState } from './StudentAttendanceSlice'
import { ShimmerTable } from 'react-shimmer-effects';
import  Loader from "../../../../components/Loader"
import { GetBranchId } from '../../../../CommonMethods/GetBranchId';
import FormatDateString from '../../../../CommonMethods/FromatDateString';

//12th jan current jan 30 21st jan
export default function ModifyStudentAttendance({type}){
    const initialState={
        "filter_data":{
            "ay_start_date":"",
            "ay_end_date":"",
            "selected_month":"",
            "selected_year":""
        },
        "attendance_date":"",
        "first_half":true,
        "second_half":true
    }
    
    const urlSearchParams = new URLSearchParams(window.location.search);
    const {setToastmessage, isSideNavBar,UpdateCall, setUpdateCall, setToastErrorMessage} = useContext(GlobalContext)
    const params = Object.fromEntries(urlSearchParams.entries());
    const [loadingModify,setLoadingModify]=useState(false)
    const [loadingTableData,setLoadingTableData]=useState(true)
    const [loadingFirst,setLoadingFirst]=useState(true)
    const start=params?.start_date?.split('T')[0]
    const end=params?.end_date?.split('T')[0]
   

    const dispatch=useDispatch()
    const selectedRows=useSelector((state)=>state.StudentsIdSlice.selectedRows.studentId)
    const studentIds=selectedRows.map((obj)=>obj.id)
   
    const [modifyAttendanceState, setmodifyAttendanceState] = useState(initialState);
    const [attendanceRecords,setAttendanceRecords]=useState([])
    const [holidayList, setHolidayList] = useState([])
    const [submitSelected, setsubmitSelected] = useState(false);
    const [queryParams,setQueryParams]=useState("")
    const [dateError,setdateError]=useState("")
    const defaultDate=new Date([2023,7,1])
    
   
    const location=useNavigate()
    const handleSelectAtendanceDate = async(id,date,dateString,termkdisabledDateey) => {
        setmodifyAttendanceState((prv) => ({
            ...prv,
            attendance_date: dateString,
        }));
        handleFetchStudentAttendance(moment(dateString).format("YYYY-MM-DD"))
    };

    
    useEffect(() => {
        
        setQueryParams(Object.entries(params)
            .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
            .join('&'))
        delete params.start_date;
        delete params.end_date;
        delete params.page_number;
        delete params.limit;
        params.search?delete params.search:""
        setmodifyAttendanceState((prv)=>({
            ...prv,
            filter_data:{
                ay_start_date:start,
                ay_end_date:end,
                selected_month:params.month,
                year:params.year
            }
        }))
        handleFetchStudentAttendance()
    }, []);
    
    const handleFetchStudentAttendance = useCallback(async (selectedDate,idTodelete) => {
        let studentIds=selectedRows.map((obj)=>obj.id)
        if(idTodelete!==undefined){
            studentIds=studentIds.filter((item)=>item!==idTodelete)
        }
        let date
        if(selectedDate){
            date=selectedDate
        }
        else{
            if(moment(start).month()===moment(params.month,'MMMM').month()){
            
                date=start
            }
            else{
                date=`${params.year}-0${moment(params.month,'MMMM').month()+1}-01`
            }
            setmodifyAttendanceState((prv)=>({
                ...prv,
                attendance_date:date
            }))
        }
        delete params.start_date;
        delete params.end_date;
        delete params.page_number;
        delete params.limit;
        if(type === "staff") {
            delete params.fy_status
            // Set `staff_type` based on `employee_type` and delete `employee_type`
            params.staff_type = params.employee_type;
            // If `staff_type` is null, undefined, or an empty string, delete it
            if (!params.staff_type) {
                delete params.staff_type;
            }
            delete params.employee_type;
        }
        params.search?delete params.search:""
        const queryParameters = Object.entries(params)
            .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
            .join('&');
        const branch_id = await GetBranchId()
        try{
            setLoadingTableData(true)
            const response=await dataService.GetAPI(`${type === "staff" ? "staff-attendance" : "student-attendance"}?branch_id=${branch_id}&${queryParameters}&${type === "staff" ? "employee_ids": "student_ids"}=${studentIds.join(',')}&date=${date}`)
            if (response.data.status === 200) {
                setLoadingTableData(false)
                setLoadingFirst(false)
                console.log(response.data.data)
                setAttendanceRecords(response.data.data.data)
                setHolidayList(Array.isArray(response.data.data?.holiday_list) ? response.data.data.holiday_list : [])
            }
            else
            {
                setLoadingTableData(false)
                setAttendanceRecords([])
                setHolidayList([])
            }
        }catch(error){
            setLoadingTableData(false)
            setHolidayList([])
        }
    }, [attendanceRecords,modifyAttendanceState.attendance_date]); 

    const selectedDateHoliday = holidayList?.[0] || null;
    const isSelectedDateHoliday = Boolean(selectedDateHoliday);
    const allowFirstHalfModification = !isSelectedDateHoliday || Boolean(selectedDateHoliday?.allow_first_half_modification);
    const allowSecondHalfModification = !isSelectedDateHoliday || Boolean(selectedDateHoliday?.allow_second_half_modification);
    const isAttendanceModificationAllowed = allowFirstHalfModification || allowSecondHalfModification;
    const isHolidayFullyLocked = isSelectedDateHoliday && !isAttendanceModificationAllowed;
    const selectedHolidayDateLabel = modifyAttendanceState?.attendance_date
        ? FormatDateString(modifyAttendanceState.attendance_date)
        : '';


    const disabledDates = (current) => {
        
        // Disable dates that are after the current date
        let startDateString=new Date(modifyAttendanceState?.filter_data?.ay_start_date)
        startDateString.setDate(startDateString.getDate()-1)
        let startDate=startDateString.toISOString()
        let endDateString=new Date(modifyAttendanceState?.filter_data?.ay_end_date)
        endDateString.setDate(endDateString.getDate())
        let endDate=endDateString.toISOString()
        let selectedMonth=moment(modifyAttendanceState?.filter_data?.selected_month,'MMMM').month()
        const monthMatches = current.month() !== selectedMonth
        if(moment(startDate).month()===(selectedMonth)){
    
            if(moment(endDate).month()===(selectedMonth)){
        
                return ((current&& current.toISOString()<startDate)||(current&& current.toISOString()>=endDate)||(monthMatches)||(current&& current>moment().endOf('day')))
            
            }
            return ((current&& current>moment().endOf('day'))||(current&& current.toISOString()<startDate)||(monthMatches))
            
            
        }
        else if(moment(endDate).month()===(selectedMonth)){
            return ((current&& current.toISOString()>endDate)||(current && current > moment().endOf('day'))||(monthMatches))
        }
        return ((current && current > moment().endOf('day'))||(monthMatches));
    };

    function handleRadiobtnChange(event){
        if(event.target.id==="first-half-present"||event.target.id==="first-half-absent"){
            setmodifyAttendanceState((prv)=>({
                ...prv,
                first_half:!(modifyAttendanceState?.first_half)
            }))
        }
        else{
            setmodifyAttendanceState((prv)=>({
                ...prv,
                second_half:!(modifyAttendanceState?.second_half)
            }))
        }

    }
    const handleUpdateAttendance=async()=>{
        if (!isAttendanceModificationAllowed) return
        setLoadingModify(true)
        setsubmitSelected(true)
        
        if(attendanceRecords?.length === 0) {
            setLoadingModify(false)
            return
        }
        let body={
            "first_half":allowFirstHalfModification ? (modifyAttendanceState?.first_half ? "present" : "absent") : attendanceRecords[0]?.first_half,
            "second_half":allowSecondHalfModification ? (modifyAttendanceState?.second_half ? "present" : "absent") : attendanceRecords[0]?.second_half,
            "date":moment(modifyAttendanceState?.attendance_date).format("YYYY-MM-DD"),
            "branch_id": attendanceRecords[0]?.branch_id,
        }
        if(type === "staff") {
            body["employee_ids"] = attendanceRecords?.map((obj)=>obj.employee_id)
        } else {
            const student_ids = attendanceRecords?.map((obj) => obj.student_uuid);
            body["student_ids"] = student_ids;
            body["academic_year_id"]= attendanceRecords[0]?.academic_year_id,
            body["class_id"]= attendanceRecords[0]?.class_id,
            body["section_id"]= attendanceRecords[0]?.section_id;
        }
        console.log(body)
        try{
            const res = await dataService.PutAPI(body, type === "staff" ?  "staff-attendance" : 'student-attendance')
            if(!res.error){
                setLoadingModify(false)
                setToastmessage('Attendance Modified Successfully')
                location(type === "staff" ? `/employee-master/employee-attendance?${queryParams}` : `/student-master/student-attendance?${queryParams}`)

            } else {
                
            }
        }catch(error){
            setLoadingModify(false)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
        }
        dispatch(resetState())
    }
    
    return(
        <div class={`w-full main-screenInst overflow-x-hidden min-h-screen max-h-screen relative`}>
            <div class="mainDataCntnrTop shadow-s13" style={{ position: "sticky", position: "-webkit-sticky" }}>
                <div class="flex items-center">
                    <h5 class="pageHeader adderror">Modify {type === "staff" ? "Employee" : "Student"} Attendance</h5>
                </div>
                <div class="flex items-center">
                    <button type="button" class="cancl-btn" onClick={()=>{dispatch(resetState()),location(`${type === "staff" ? "/employee-master/employee-attendance" : "/student-master/student-attendance"}?${queryParams}`)}}>Cancel
                    </button>
                    <UpdateButton
                        ButtonName="Update"
                        loading={loadingModify}
                        handleOnCLick={handleUpdateAttendance}
                        classKey="actn-btn onboardInstitution"
                        disabled={!isAttendanceModificationAllowed}
                    />
                </div>
            </div>
            <div class="mainDataCntnrPageDiv scrollBlue_thick">
                <div className='relative'>
                    <div class="w-[80%] 2xl:w-[75%] mx-auto pb-10">
                        <div class="border border-[#C2DCEF] bg-[#EEF7FE] rounded-sm px-3 py-2">
                            <p class="text-center text-f7 font-normal text-[#000]">
                                {
                                    type === "staff" ?
                                        <span>
                                            Choose a Date and modify attendance for the below selected Employees in school web application. Use the search function to add more employees.
                                        </span>
                                        :
                                        <span>
                                            Choose a Date and modify attendance for the below selected Students. Use the search function to add more students.
                                        </span>
                                }
                            </p>
                        </div>
                        <div class="mt-4 mb-6 p-3 border border-[#D0D5DD] rounded flex ">
                            {type !== "staff" ? <><div class="w-1/2 px-1">
                                <div class="flex mb-3">
                                    <a class="w-[35%]" id="po_amount_label">Academic Year</a>
                                    <a class="font-semibold break-all w-[70%]" id="po_amount">{params.academic_year}</a>
                                </div>
                                <div class="flex mb-3">
                                    <a class="w-[35%]" id="po_amount_label">Class</a>
                                    <a class="font-semibold break-all w-[70%]" id="po_amount">{params.class_name}</a>
                                </div>
                                <div class="flex mb-3">
                                    <a class="w-[35%]" id="po_amount_label">Section</a>
                                    <a class="font-semibold break-all w-[70%]" id="po_amount">{params.section_name}</a>
                                </div>
                                <div class="flex">
                                    <a class="w-[35%]" id="po_amount_label">Month</a>
                                    <a class="font-semibold break-all w-[70%]" id="po_amount">{params.month}</a>
                                </div>
                            </div></> :<>
                                <div class="w-1/2 px-1">
                                    <div class="flex mb-4">
                                        <a class="w-[35%]" id="po_amount_label">Financial Year</a>
                                        <a class="font-semibold break-all w-[70%]" id="po_amount">{params.financial_year}</a>
                                    </div>
                                    <div class="flex mb-4">
                                        <a class="w-[35%]" id="po_amount_label">Month</a>
                                        <a class="font-semibold break-all w-[70%]" id="po_amount">{params.month}</a>
                                    </div>                                    
                                </div></>
                            }
                            <div class="w-1/2 px-1">
                                <div class="w-full flex justify-center">
                                    <div style={{ 'min-width': '66%' }}>
                                        <div class="relative flex items-center justify-center w-full mb-3">
                                            <label for="Select_DOB" class="text-f7 font-normal text-[#031624] w-[44%] inline-flex">Date</label>
                                            <div class="relative w-[58%] 2xl:w-[55%] ">
                                                <CustomeDatePicker
                                                    id="attendance_date"
                                                    showErrorBorder = {(submitSelected && modifyAttendanceState?.attendance_date === "")}
                                                    isMandatoryField={true}
                                                    format="MMM DD, YYYY"
                                                    state={modifyAttendanceState}
                                                    placeholder="Select Date"
                                                    handleSelect={handleSelectAtendanceDate}
                                                    setdateError={setdateError}
                                                    termkey={modifyAttendanceState.attendance_date}
                                                    disabledFutureDate={disabledDates}
                                                    imageClass={true}
                                                    defaultValue={defaultDate} />
                                            </div>
                                        </div>
                                        <div class="flex items-center mb-4">
                                            <p class="text-f7 font-normal text-[#031624] min-w-[120px]">First Half</p>
                                            {!allowFirstHalfModification ? (
                                                <div class="relative custom-radioBlue flex items-center">
                                                    <input id="first-half-holiday" type="radio" name="default-radio" checked={true} disabled={true} />
                                                    <label for="first-half-holiday" class="text-sm font-normal text-[#031624] w-full cursor-not-allowed opacity-50">Holiday</label>
                                                </div>
                                            ) : (
                                                <>
                                                    <div class="relative custom-radioBlue flex items-center">
                                                        <input id="first-half-present" type="radio" name="default-radio" checked={modifyAttendanceState?.first_half?true:false}  onChange={handleRadiobtnChange}/>
                                                        <label for="first-half-present" class="text-sm font-normal text-[#031624] w-full cursor-pointer">Present</label>
                                                    </div>
                                                    <div class="relative custom-radioBlue flex items-center ml-3.5 2xl:ml-6">
                                                        <input id="first-half-absent" type="radio" name="default-radio"checked={!modifyAttendanceState?.first_half?true:false} onChange={handleRadiobtnChange} />
                                                        <label for="first-half-absent" class="text-sm font-normal text-[#031624] w-full cursor-pointer">Absent</label>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                        <div class="flex items-center">
                                            <p class="text-f7 font-normal text-[#031624] min-w-[120px]">Second Half</p>
                                            {!allowSecondHalfModification ? (
                                                <div class="relative custom-radioBlue flex items-center">
                                                    <input id="second-half-holiday" type="radio" name="default-radio1" checked={true} disabled={true} />
                                                    <label for="second-half-holiday" class="text-sm font-normal text-[#031624] w-full cursor-not-allowed opacity-50">Holiday</label>
                                                </div>
                                            ) : (
                                                <>
                                                    <div class="relative custom-radioBlue flex items-center">
                                                        <input id="second-half-present" type="radio" name="default-radio1"checked={modifyAttendanceState?.second_half?true:false}  onChange={handleRadiobtnChange} />
                                                        <label for="second-half-present" class="text-sm font-normal text-[#031624] w-full cursor-pointer">Present</label>
                                                    </div>
                                                    <div class="relative custom-radioBlue flex items-center ml-3.5 2xl:ml-6">
                                                        <input id="second-half-absent" type="radio" name="default-radio1"checked={!modifyAttendanceState?.second_half?true:false} onChange={handleRadiobtnChange} />
                                                        <label for="second-half-absent" class="text-sm font-normal text-[#031624] w-full cursor-pointer">Absent</label>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {isHolidayFullyLocked &&
                            <div class="mb-4 rounded border border-[#FECACA] bg-[#FEF2F2] px-4 py-3">
                                <p class="text-f7 font-normal text-[#B42318]">
                                    {selectedHolidayDateLabel} is holiday. Hence no modifications allowed to attendance.
                                </p>
                            </div>
                        }
                        <div class="flex items-end justify-between">
                            <p class="text-lg font-semibold text-[#000000]">Selected {type === "staff" ? "Employees" : "Students"}</p>
                            <SearchBar 
                                type={type}
                                attendanceRecords={attendanceRecords}
                                setAttendanceRecords={setAttendanceRecords} 
                                handleFetchStudentAttendance={handleFetchStudentAttendance} 
                                selectedDate={modifyAttendanceState.attendance_date} 
                                params={params} 
                                setLoading={setLoadingTableData} 
                            />
                        </div>
                        <div class="-mx-1">
                            <div class="flex mt-2 overflow-x-hidden pb-3 scroll-bar px-1 flex-col">
                                {loadingTableData ? <div className="w-full table-auto "><ShimmerTable row={9} col={4} /></div> : <Table
                                    selectedAttendanceRecords={attendanceRecords}
                                    setAttendanceRecords={setAttendanceRecords}
                                    handleFetchStudentAttendance={handleFetchStudentAttendance}
                                    selectedDate={modifyAttendanceState.attendance_date}
                                    type={type}
                                    params={params}
                                    disableRemove={!isAttendanceModificationAllowed}
                                />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         
        </div>
        
                        
    )
}
